import Vue from 'vue'
import Router from 'vue-router'
import Example from './views/example.vue'
import Abnormal from './components/404/abnormal.vue';
import Unusual from './components/502/unusual.vue'
import AbnormalOne from './components/404/abnormal-one.vue'
import IOSclient from './views/IOSclient/index'
import IOSopen from './views/IOSopen/index'
import Verification from './views/IOSverification/index'
import AppPrivacy from './views/app-privacy/app-privacy';


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'IOSclient',
      component: IOSclient
    },
    {
      path: '/app-privacy',
      name: 'AppPrivacy',
      component: AppPrivacy
    },
    {
      path: '/abnormal',
      name: 'abnormal',
      component: Abnormal
    },
    {
      path: '/unusual',
      name: 'unusual',
      component: Unusual
    },
    {
      path: '/abnormalOne',
      name: 'abnormalOne',
      component: AbnormalOne
    },
    {
      path: '/verification',
      name: 'Verification',
      component: Verification
    },
    {
      path: '/iosclient',
      name: 'IOSclient',
      component: IOSclient
    },
    {
      path: '/iosopen',
      name: 'IOSopen',
      component: IOSopen
    },
  ]
})
